import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import EmailValidation from './components/EmailValidation-with-tracker';
import OnboardingNSL from './components/OnboardingNSL';
import JoinDiscordPage from './components/JoinDiscordPage';
import OnboardingCompletePage from './components/OnboardingCompletePage';

function OnboardingFlow() {
  const [validatedEmail, setValidatedEmail] = useState(null);

  const handleValidationSuccess = (email) => {
    setValidatedEmail(email);
  };

  if (validatedEmail) {
    return <OnboardingNSL validatedEmail={validatedEmail} />;
  }

  return <EmailValidation onValidationSuccess={handleValidationSuccess} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/join-discord" element={<JoinDiscordPage />} />
        <Route path="/complete" element={<OnboardingCompletePage />} />
        <Route path="/" element={<OnboardingFlow />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;